import { atom } from 'recoil';

const currentCategoryState = atom({
  key: 'currentCategoryState',
  default: '',
});

export { currentCategoryState };
